<template>
    <div>
        <div class="header-btn">
            <el-button size="small" type="warning" @click="openCreate" icon="el-icon-plus"></el-button>
        </div>

        <el-table
                :data="data"
                style="width: 100%">
            <el-table-column
                    header-align="center"
                    align="center"
                    label="Banner">
                <template slot-scope="s">
                    <template v-if="isVideo(s.row.pic.path)">
                        <video :src="s.row.pic.path | filePath" width="100px"/>
                    </template>
                    <template v-else>
                        <img :src="s.row.pic.path | filePath" width="100px" alt="p"/>
                    </template>
                </template>
            </el-table-column>

            <el-table-column
                    header-align="center"
                    align="center"
                    label="Slot">
                <template slot-scope="s">
                    {{s.row.slot |slotsFilter }}
                </template>
            </el-table-column>

            <el-table-column
                    header-align="center"
                    align="center"
                    label="Action">
                <template slot-scope="s">
                    <el-button type="danger" circle @click="deleteData(s.row.id)"
                               icon="el-icon-delete"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
                center
                title="Upload New banner"
                :visible.sync="dialog"
                :close-on-click-modal="false"
                width="600px">
            <el-form ref="form" :model="banner" label-width="100px" label-position="left" :rules="rules">
                <el-form-item label="Title" prop="title">
                    <el-input v-model="banner.title"></el-input>
                </el-form-item>

                <el-form-item label="Banner">
                    <icon-uploader :fid.sync="banner.fid" :url.sync="banner.url"></icon-uploader>
                </el-form-item>

                <el-form-item label="Slot" prop="slot">
                    <el-select v-model="banner.slot" placeholder="Banner slot">
                        <el-option
                                v-for="item in [{label:'Home Page',value:'1'},
                                {label:'Home Service',value:'2'},
                                {label:'Unlock(only support video)',value:'3'}]"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Sequence" prop="sort">
                    <el-input-number v-model="banner.sort" :min="0"></el-input-number>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="save">Save</el-button>
                <el-button @click="dialog = false">Cancel</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {filePath} from '@/utils/AwsUtils'
    import {banners, createBanner, deleteBanner} from '@/api/system'
    import IconUploader from '../../../components/IconUploader'
    // noinspection JSUnusedGlobalSymbols
    export default {
        name: 'Banner',
        components: {IconUploader},
        data: function () {
            return {
                banner: {},
                loading: false,
                dialog: false,
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                rules: {
                    title: [
                        {required: true, message: 'Title is required', trigger: 'blur'},
                    ],
                    sort: [
                        {required: true, message: 'Sort is required', trigger: 'blur'},
                    ],
                    slot: [
                        {required: true, message: 'Slot is required', trigger: 'blur'},
                    ],
                }
            }
        },
        methods: {
            isVideo(path) {
                return /.*(.mp4|.avi)$/.test(path)
            },
            loadData() {
                this.$pageUtils(this, banners)
            },
            openCreate() {
                this.banner = {}
                this.dialog = true
            },
            save() {
                this.banner.openType = 1
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        createBanner(this.banner)
                            .then(() => {
                                this.dialog = false
                                this.loadData()
                            })
                    }
                })
            },
            deleteData(id) {
                this.$deleteRequest(this, deleteBanner, id)
            }
        },
        mounted() {
            this.loadData()
        },
        filters: {
            filePath(val) {
                return filePath(val)
            },
            slotsFilter(val) {
                return {
                    1: 'Home Page',
                    2: 'Home Service',
                    3: 'Unlock',
                }[val]
            }
        }
    }
</script>

<style scoped>

</style>
